import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssn'
})
export class SsnPipe implements PipeTransform {

  transform(value: any, args?: any): any {
      if (value == null) {
          return 'Invalid SSN Number (null)';
      }

      

      return 'XXX-XX-' + value.substring(value.length - 4, value.length);
  }
}

